export default {
  clearFilter({ commit }) {
    commit("setFilterTitle", "")
    commit("setFilterPublicationDate", "")
  },

  addUpload: ({ state, commit }, file) => {
    const newFiles = [...state.report.uploads, file]
    commit("setUploads", newFiles)
  },
  deleteFileUpload: ({ state, commit }, indexFile) => {
    const newFiles = state.report.uploads.filter(
      (file, index) => index !== indexFile
    )
    commit("setUploads", newFiles)
  },

  addNewFiles: ({ state, commit }, file) => {
    const newFiles = [...state.report.newFiles, file]
    commit("setNewFiles", newFiles)
  },
  deleteNewFile: ({ state, commit }, indexFile) => {
    const newFiles = state.report.newFiles.filter(
      (file, index) => index !== indexFile
    )
    commit("setNewFiles", newFiles)
  },

  addNewDeleteFileId: ({ state, commit }, file) => {
    const newFiles = [...state.report.deletedFilesIds, file]
    commit("setDeletedFilesIds", newFiles)
  },

  pushSteps: ({ state, commit }, step) => {
    const newSteps = [...state.steps, step]
    commit("setSteps", newSteps)
  },

  spliceSteps: ({ state, commit }, indexOfStep) => {
    const newSteps = [...state.steps]
    newSteps.splice(indexOfStep, 1)
    commit("setSteps", newSteps)
  },

  pushStepNameRoutes: ({ state, commit }, step) => {
    const newSteps = [...state.step_name_routes, step]
    commit("setStepNameRoutes", newSteps)
  },

  spliceStepNameRoutes: ({ state, commit }, indexOfStep) => {
    const newSteps = [...state.step_name_routes]
    newSteps.splice(indexOfStep, 1)
    commit("setStepNameRoutes", newSteps)
  }
}
